import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chart",
  "use": "chart-usage",
  "viewBox": "0 0 18.969 17.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.969 17.969\" id=\"chart\">\n  <path fill-rule=\"evenodd\" d=\"M149.113,448H131.906a0.844,0.844,0,1,1,0-1.686h17.207A0.844,0.844,0,1,1,149.113,448Zm-0.89-3.372H145.85a1.156,1.156,0,0,1-1.187-1.124V431.141a1.157,1.157,0,0,1,1.187-1.124h2.373a1.158,1.158,0,0,1,1.187,1.124V443.5A1.157,1.157,0,0,1,148.223,444.628ZM147.63,431.7h-1.187v11.239h1.187V431.7ZM141.7,444.628h-2.373a1.157,1.157,0,0,1-1.187-1.124v-7.867a1.157,1.157,0,0,1,1.187-1.124H141.7a1.156,1.156,0,0,1,1.187,1.124V443.5A1.156,1.156,0,0,1,141.7,444.628ZM141.1,436.2h-1.187v6.743H141.1V436.2Zm-5.933,8.429H132.8a1.156,1.156,0,0,1-1.186-1.124v-3.372a1.157,1.157,0,0,1,1.186-1.124h2.374a1.157,1.157,0,0,1,1.186,1.124V443.5A1.156,1.156,0,0,1,135.17,444.628Zm-0.594-3.934H133.39v2.248h1.186v-2.248Z\" transform=\"translate(-131.031 -430.031)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/chart.svg
// module id = null
// module chunks = 